import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { RootStoreContext } from "../../../stores/RootStore";

import { TrashIcon } from "@heroicons/react/24/solid";
import { observer } from "mobx-react-lite";
import { arraySum, displayDate, displayDollarAmount } from "../../../lib/utilities";
import { IMaintenanceRepair } from "../../../models/MaintenanceRepair/MaintenanceRepair";
import Table from '../../table/Table';
import TBody from '../../table/TBody';
import TD from '../../table/TD';
import THead from '../../table/THead';
import TR from '../../table/TR';
import MaintenanceRepairAutoCompleteInput from "../MaintenanceRepairAutoCompleteInput";

interface OwnProps {
  onChange?: (e) => (void)
  name?: string
  selected?: string[]
  entityStateId?: string
}

type Props = OwnProps;

const MaintenanceRepairMultiselect: FunctionComponent<Props> = ({entityStateId, onChange, name, selected}) => {
  //Stores
  const rootStore = useContext(RootStoreContext);
  const {newSubItemQueue} = rootStore.subItemStore


  // Local State
  const [availableMaintenanceRepairs, setAvailableMaintenanceRepairs] = useState([] as IMaintenanceRepair[]);
  const [selectedMaintenanceRepairs, setSelectedMaintenanceRepairs] = useState([] as Array<IMaintenanceRepair>);

  const getMaintenanceRepairByIds = (id: string)  => availableMaintenanceRepairs.find(x=> x.id === id)
  useEffect(() => {
    if (!!selected && selected?.length > 0) {
      selected.forEach(id => {
        const data = getMaintenanceRepairByIds(id)
        if (!!data) setSelectedMaintenanceRepairs(prev => [...prev, data])
      })
    }
  }, [availableMaintenanceRepairs, newSubItemQueue]);

  // Functions
  const handleRemove = (idx): void => {
    setSelectedMaintenanceRepairs((prev) => {
      const tmp = [ ...prev ]
      tmp.splice(idx, 1)
      !!onChange && onChange({
        currentTarget: {
          name,
          value: tmp.map(ids => ids?.id)
        }
      })
      return tmp
    })
  }

  const handleSelected = (data): void => {
    if (!data.id)
      return

    if (!!data) {
      let newMaintenanceRepair = availableMaintenanceRepairs.find((maintenanceRepair) => {
        return maintenanceRepair.id === data.id
      })

      // @ts-ignore
      setSelectedMaintenanceRepairs(prev => {
        let tmp = [...prev, newMaintenanceRepair]
        !!onChange && onChange({
          currentTarget: {
            name,
            value: tmp.map(ids => ids?.id)
          }
        })
        return tmp
      })
    }
  }

  return (<>
    {/* <pre>{JSON.stringify(availableMaintenanceRepairs, null, 2)}</pre> */}
    <div className={'grid grid-cols-1 sm:grid-cols-1 gap-x-4 gap-y-1'}>
      <MaintenanceRepairAutoCompleteInput
        onFetchSuccess={setAvailableMaintenanceRepairs}
        entityStateId={entityStateId}
        onChange={handleSelected}
        filterIds={!!selectedMaintenanceRepairs.length ? selectedMaintenanceRepairs?.map((selected: IMaintenanceRepair) => selected?.id ?? '') : []}
      />
    </div>

    <Table>
      <THead>
        <TR>
          <TD/>
          <TD>Consumer</TD>
          <TD>Technician</TD>
          <TD>Equipment</TD>
          <TD>Date Performed</TD>
          <TD>Repair, Maintenance, Refurbish, or Warranty Time</TD>
          <TD>Total Cost</TD>
        </TR>
      </THead>
      <TBody>
        {selectedMaintenanceRepairs.map((maintenanceRepair: IMaintenanceRepair, idx) => {
          return (<TR key={idx}>
            <TD><TrashIcon className={'text-red-600 h-6 w-6'} onClick={() => handleRemove(idx)}/></TD>
            <TD>{maintenanceRepair?.consumerName || 'Inventory'}</TD>
            <TD>{maintenanceRepair?.technicianName ?? ''}</TD>
            <TD>{maintenanceRepair?.equipmentName ?? ''}</TD>
            <TD>{displayDate(maintenanceRepair?.datePerformed ?? '')}</TD>
            <TD>{maintenanceRepair?.rmrwTime ?? ''} {!!maintenanceRepair?.rmrwTime && maintenanceRepair?.rmrwTime > 1 ? 'hours' : 'hour'}</TD>
            <TD>{displayDollarAmount(arraySum([
              maintenanceRepair?.auxiliaryAidCosts,
              maintenanceRepair?.timeMaterialsCosts,
              maintenanceRepair?.otherCosts,
            ]))}</TD>
          </TR>)
        })}
      </TBody>
    </Table>
  </>);
};

export default observer(MaintenanceRepairMultiselect);
